import 'vue-multiselect/dist/vue-multiselect.min.css';

import VeeValidate from 'vee-validate';

import CardHeader from "@/components/Includes/CardHeader/CardHeader.vue";
import ILandingDomain from "@/interfaces/ILandingDomain";
import capitalizeFirstLetter from "@/libs/capitalizeFirstLetter";
import Multiselect from 'vue-multiselect';
import {Component, Prop, Vue} from 'vue-property-decorator';

import IMultiSelectItem from '@/interfaces/selects/IMultiSelectItem';
import {Switch as cSwitch} from '@coreui/vue';


Vue.use(VeeValidate, {
    inject: true,
    fieldsBagName: 'veeFields'
});


@Component({
    name: 'LandingDomainForm',
    components: {
        Multiselect,
        CardHeader,
        cSwitch
    }
})
export default class LandingDomainForm extends Vue {
    @Prop(Object) private formData!: ILandingDomain;
    @Prop(Array) private landingRegions!: IMultiSelectItem[];
    @Prop(Boolean) private loading!: boolean;
    @Prop(Boolean) private isCreateForm!: boolean;

    // Begin Handler by Form
    private checkDescription(field: string): string {
        return field === 'url' ? `Example: hostname.com` : '';
    }

    private checkRequired(field: string): string {
        const requiredFields = [
            'url',
            'region'
        ];

        return field === 'url' ? 'required|url' : (requiredFields.indexOf(field) !== -1 ? 'required' : 'min:1');
    }


    private invalidValue(fieldName: string) {
        return this.$validator.errors.has(fieldName);
    }

    private handleSave() {
        this.validateForm();
    }

    private validateForm() {
        this.$validator.validateAll().then((result) => {
            if (result) {
                this.$emit('createLandingDomain');
            }
        });
    }

    // End Handler by Form

    private get disabledField(): boolean {
        return !this.isCreateForm;
    }

    private transformValue(value: any): string {
        return value ? String(value) : '–';
    }

    private transformLabel(field: string): string {
        return capitalizeFirstLetter(field);
    }

    private hideFields(field: string): boolean {
        return field === 'id' || field === 'expiresAt';
    }
}
